// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");

function configId(t) {
  return t.configId;
}

function name(t) {
  return t.name;
}

function host(t) {
  return t.host;
}

function port(t) {
  return t.port;
}

function username(t) {
  return t.username;
}

function password(t) {
  return t.password;
}

function isActive(t) {
  return t.isActive;
}

function setName(t, name) {
  return {
          configId: t.configId,
          name: name,
          host: t.host,
          port: t.port,
          username: t.username,
          password: t.password,
          isActive: t.isActive
        };
}

function setHost(t, host) {
  return {
          configId: t.configId,
          name: t.name,
          host: host,
          port: t.port,
          username: t.username,
          password: t.password,
          isActive: t.isActive
        };
}

function setPort(t, port) {
  return {
          configId: t.configId,
          name: t.name,
          host: t.host,
          port: port,
          username: t.username,
          password: t.password,
          isActive: t.isActive
        };
}

function setUsername(t, username) {
  return {
          configId: t.configId,
          name: t.name,
          host: t.host,
          port: t.port,
          username: username,
          password: t.password,
          isActive: t.isActive
        };
}

function setPassword(t, password) {
  return {
          configId: t.configId,
          name: t.name,
          host: t.host,
          port: t.port,
          username: t.username,
          password: password,
          isActive: t.isActive
        };
}

function setIsActive(t, isActive) {
  return {
          configId: t.configId,
          name: t.name,
          host: t.host,
          port: t.port,
          username: t.username,
          password: t.password,
          isActive: isActive
        };
}

function fromJson(json) {
  return {
          configId: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json),
          host: Json_decode.field("host", Json_decode.string, json),
          port: Json_decode.field("port", Json_decode.string, json),
          username: Json_decode.field("username", Json_decode.string, json),
          password: Json_decode.optional((function (param) {
                  return Json_decode.field("password", Json_decode.string, param);
                }), json),
          isActive: Json_decode.field("active", Json_decode.bool, json)
        };
}

function decode(json) {
  return Json_decode.field("sftp_configuration", fromJson, json);
}

var initialConf = {
  configId: 1,
  name: "",
  host: "",
  port: "22",
  username: "",
  password: undefined,
  isActive: true
};

exports.configId = configId;
exports.name = name;
exports.host = host;
exports.port = port;
exports.username = username;
exports.password = password;
exports.isActive = isActive;
exports.setName = setName;
exports.setHost = setHost;
exports.setPort = setPort;
exports.setUsername = setUsername;
exports.setPassword = setPassword;
exports.setIsActive = setIsActive;
exports.initialConf = initialConf;
exports.fromJson = fromJson;
exports.decode = decode;
/* No side effect */
